import { createContext, useCallback, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";

const PortalPageContext = createContext(null);
PortalPageContext.displayName = "PortalPageContext";

export function PortalPageContextProvider({ children }) {
  const [pageContext, setPageContextState] = useState(null);

  const setPageContext = useCallback((next) => {
    setPageContextState(next || null);
  }, []);

  const value = useMemo(
    () => ({
      pageContext,
      setPageContext,
    }),
    [pageContext, setPageContext]
  );

  return <PortalPageContext.Provider value={value}>{children}</PortalPageContext.Provider>;
}

PortalPageContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function usePortalPageContext() {
  const ctx = useContext(PortalPageContext);
  if (!ctx) {
    throw new Error("usePortalPageContext must be used within PortalPageContextProvider.");
  }
  return ctx;
}
